import {
  CustomGeoJSONFeature,
  GeoJSONFeatureCollection,
  MapItem,
} from '@components/MapView/types/mapView.types';
import type { FeatureCollection, Point } from 'geojson';

export default function mapItemToFeatureCollection<Item>(
  items: MapItem<Item>[],
): FeatureCollection<Point> & GeoJSONFeatureCollection<Item> {
  return {
    type: 'FeatureCollection',
    features: items.map(
      (item, index): CustomGeoJSONFeature<Item> => ({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [item.longitude, item.latitude] as [number, number],
        },
        properties: {
          id: `item-${index}`,
          originalItem: item.item,
        },
      }),
    ),
  };
}
